<template>
  <div>
    <b-overlay
      :show="loadTeachers"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="md"
    >
      <div class="resetTeachers text-center" v-if="subgroupTeachers.length != 0">
        <b-button variant="danger" @click="subgroupTeacherList()" size="sm"
          >Clear all</b-button
        >
      </div>
      <div class="d-flex mt-3" style="height: 200px">
        <div class="subgroupNames w-100" style="overflow-y: scroll">
          <b-form-checkbox
            size="sm"
            v-for="(subgroup, subgroupIndex) in subgroupsTeachersOptions"
            :key="subgroupIndex"
            v-model="selectedSubgroupsTeachers"
            :value="subgroup.value"
            :disabled="subgroup.disabled"
            @change="callSubgroupTeachersApi(subgroup.value)"
            >{{ subgroup.text }}</b-form-checkbox
          >
        </div>
      </div>
        
        <!-- <div
          class="subgroupTeachers w-50"
          v-if="subgroupTeachers.length != 0"
          style="overflow-y: scroll"
        >
          <div class="users d-flex flex-wrap">
            <p
              v-for="(teacher, teacherIndex) in subgroupTeachers"
              :key="teacherIndex"
              class="bg-success p-2 text-white rounded ml-2"
              style="font-size: 12px"
            >
              {{ teacher.course + "-" + teacher.instructor }}
              <span
                class="text-white btn m-0 p-0"
                @click="subgroupTeachers.splice(teacherIndex, 1)"
                ><i class="far fa-times-circle ml-2"></i
              ></span>
            </p>
          </div>
        </div> -->
        
        <div>
          <b-modal id="CTCModal" no-close-on-backdrop no-close-on-keyboard no-close-on-esc size="xl" @ok="saveChanges">
                        
            <!-- Header -->
            <template #modal-title>
              Edit Course Faculty Combinations
            </template>

            <!-- Body -->
            <div class="mb-2" v-if="availableSubtypes.length > 0">
              <label for="">Filter by subtype : </label> <br>
              <b-form-checkbox-group v-model="selectedSubtypes" :options="availableSubtypes.map(s => ({ value: s, text: s }))" size="sm"></b-form-checkbox-group>
            </div>
            <div class="modal-body">
              <table class="table table-bordered">

                <!-- TABLE HEADER -->
                <thead>
                  <tr>
                    <th v-for="(value, key) in groupedSubgroupTeachers" :key="key" style="min-width: 250px">
                      {{ value.name }}
                      <span v-if="value.programme_code" class="class-programme-code">{{ value.programme_code }}</span>
                    </th>
                  </tr>
                </thead>

                <!-- TABLE BODY -->
                <tbody>
                  <tr>
                    <td v-for="(value, key) in groupedSubgroupTeachers" :key="key">

                      <div v-for="teacher in value.teachers" :key="teacher.course_user_id">
                        <b-form-checkbox type="checkbox" v-model="teacher.selected"> {{ teacher.instructor + '-'+ teacher.course }}</b-form-checkbox>
                      </div>

                    </td>
                  </tr>
                </tbody>

              </table>
            </div>
          </b-modal>
        </div>
      <button class="btn btn-primary my-4" type="button" @click="$bvModal.show('CTCModal')">Edit Course Faculty Combinations:</button>
    </b-overlay>
  </div>
</template>

<script>
export default {
  props: ["subgroupsForTeachers", "surveyId", "isEdit"],
  async created() {
    await this.subgroups;
    await this.subgroupTeacherList();

    if(this.isEdit){

      // console.log('isEdit',this.isEdit)
      await this.getCourseTeacherCombination();

      // console.log('this.existingCourseTeacherCombinations',this.existingCourseTeacherCombinations)

      //Get unique subgroup Ids.
      this.selectedSubgroupsTeachers = [...new Set(this.existingCourseTeacherCombinations.map(item => item.course.usersubgroup_id))]

      //Get teachers list for each subgroup.
      this.loadTeachers = true;
      for (const id of this.selectedSubgroupsTeachers) {
        await this.getSubgroupTeachers(id)
      }
      this.loadTeachers = false;

      //To find the existing course teacher combinations and mark them as selected in the UI.
      //Creating pairs of course_id and teacher_id from existing combinations for easy comparison because in the subgroupTeachers 
      //we have course_id and institution_user_id(teacher_id) and in existingCourseTeacherCombinations we have course with course_id and teacher_id as institution_user_id.
      const existingPairs = this.existingCourseTeacherCombinations.map(item => ({
        course_id: item.course.id,
        teacher_id: item.teacher_id
      }))

      // console.log('existingPairss', existingPairs);

      //Iterating through the subgroupTeachers and checking if the pair of course_id and teacher_id exists in the existingPairs, if yes then mark it as selected.
      this.subgroupTeachers.forEach(teacher => {
        const match = existingPairs.some(
          pair =>
            pair.course_id === teacher.course_id &&
            pair.teacher_id === teacher.institution_user_id
        )

        teacher.selected = match
      })
      this.savedCourseUsers = this.selectedCourseUsers;

      // console.log('subgroupTeachers', this.subgroupTeachers);

    }

  },

  data() {
    return {
      loadTeachers: false,
      subgroupsTeachersOptions: this.subgroups,
      selectedSubgroupsTeachers: [],
      subgroupTeachers: [],
      showModalCTC: false, //Course Teacher Combination
      selectedSubtypes: [],
      existingCourseTeacherCombinations: [],
      savedCourseUsers: null, // combinations last saved, to know about unsaved changes in edit; null until loaded
      savingCourseUsers: null, // save in progress
    };
  },
  watch: {
    selectedSubtypes(newVal) {
      if (newVal.length > 0) {
        this.subgroupTeachers.forEach(item => {
          item.selected = newVal.includes(item.subtype_name)
        })
      }
    }
  },
  computed: {
    selectedCourseUsers() {
      return this.subgroupTeachers
        .filter(t => t.selected)
        .map(t => t.course_user_id)
        .sort()
        .join(",");
    },
    availableSubtypes() {
      const subtypes = this.subgroupTeachers
        .map(item => item.subtype_name)
        .filter(s => s != null && s !== '')
      return [...new Set(subtypes)]
    },
    groupedSubgroupTeachers() {
      const filtered = this.selectedSubtypes.length > 0
        ? this.subgroupTeachers.filter(item => this.selectedSubtypes.includes(item.subtype_name))
        : this.subgroupTeachers
      return filtered.reduce((groups, item) => {
        const id = item.usersubgroup_id
        if (!groups[id]) {
          const subgroup = (this.subgroupsForTeachers || []).find(option => option.value == id)
          // class with its programme name, like the participants popup
          groups[id] = {
            name: subgroup ? subgroup.text : item.usersubgroup_name,
            programme_code: subgroup ? subgroup.programme_code : null,
            teachers: []
          }
        }
        groups[id].teachers.push(item)
        return groups
      }, {})
    }
  },
  methods: {
    async saveChanges(){
      if(this.isEdit){
        await this.prepareSyncTeachersPostData();
      }
    },
    // classes ticked in edit are saved only on the combinations popup OK; saving also
    // adds their students to participants, so save before the participants popup opens.
    // Only when changed, as saving adds back students removed from participants.
    async saveIfChanged() {
      // a save already running is waited for, not repeated - two saves at once
      // add back students removed from participants
      if (this.savingCourseUsers) return this.savingCourseUsers;
      // savedCourseUsers is null while the saved combinations are still loading,
      // saving then would drop the ones not loaded yet
      if (this.isEdit && this.savedCourseUsers != null && this.selectedCourseUsers != this.savedCourseUsers) {
        this.savingCourseUsers = this.prepareSyncTeachersPostData();
        try {
          await this.savingCourseUsers;
        } finally {
          this.savingCourseUsers = null;
        }
      }
    },
    async getCourseTeacherCombination() {
      this.fetchData = true;

      const url =
        this.$store.getters.getAPIKey.studentFeedbackSurvey +
        `/${this.surveyId}/studfbsurveycourseteachers`;

      try {
        const response = await this.$axios.get(url);

        this.existingCourseTeacherCombinations = response.data;

      } catch (error) {
        this.$toast.error("Something went wrong!", {
          position: "top",
          duration: 3000,
        });
        this.cancel();
      }

      this.fetchData = false;
    },
    async subgroupTeacherList() {
      this.subgroupsTeachersOptions = [];
      this.subgroupTeachers = [];
      this.selectedSubgroupsTeachers = [];
      this.subgroupsTeachersOptions = this.subgroupsForTeachers;
      this.subgroupsTeachersOptions.forEach((subgroup) => {
        subgroup.disabled = false;
      });
    },
    async prepareSyncTeachersPostData() {
      //Variable defined for API
      const course_users = this.subgroupTeachers
                          .filter(t => t.selected)
                          .map(t => t.course_user_id);

      //********** Calling Sync Teachers API **********/
      const syncTeachers = await this.syncTeachersWithFeedbackSurvey(course_users);

      //***************API RESPONSE ****************
      //***************SUCCESS RESPONSE ****************
      if (syncTeachers) {
        this.savedCourseUsers = course_users.slice().sort().join(",");
        this.$toast.success(`Linking course teachers successfully done.`, {
          position: "top",
          duration: 3000,
        });
      }
      //***************ERROR RESPONSE ****************
      if (!syncTeachers) {
        this.$toast.error(`Linking course teachers failed, Please try again`, {
          position: "top",
          duration: 3000,
        });
      }
    },
    //Syncing Course Teachers with Survey
    async syncTeachersWithFeedbackSurvey(course_users) {
      let syncUrl = this.$store.getters.getAPIKey.studentFeedbackSurveySyncTeachers;
      const url = syncUrl.replace("survey_id", this.surveyId);
      let status = null;
      await this.$axios
        .post(url, { course_users: course_users, course_teachers: [] })
        .then((response) => {
          status = true;
          response;
        })
        .catch((error) => {
          status = false;
          error;
        });
      return status;
    },
    async callSubgroupTeachersApi(subgroupId){
      // unticked: drop the class's course faculty combinations
      if (!this.selectedSubgroupsTeachers.includes(subgroupId)) {
        this.subgroupTeachers = this.subgroupTeachers.filter(t => t.usersubgroup_id != subgroupId);
        return;
      }
      this.loadTeachers = true;
      await this.getSubgroupTeachers(subgroupId);
      this.loadTeachers = false;
    },
    async getSubgroupTeachers(subgroupId) {
      // this.loadTeachers = true;
      const subgroupTeacherId = await this.selectedSubgroupsTeachers.findIndex(
        (subgroup) => {
          return subgroup == subgroupId;
        }
      );
      const url = `${this.$store.getters.getAPIKey.mainAPI}/usersubgroup/${subgroupId}/courses/withinstructors`;
      await this.$axios.get(url).then((response) => {
        const subgroupUsers = response.data;
        if (subgroupUsers.length == 0) {
          this.$toast.warning("No users found!", {
            position: "top",
            duration: 3000,
          });
          this.selectedSubgroupsTeachers.splice(subgroupTeacherId, 1);
        } else {
          const checkTeachersExist = [];
          subgroupUsers.forEach((course) => {
            course.institution_users.forEach((instructor) => {
              if (instructor.pivot.courserole_id == 1) {
                this.subgroupTeachers.push({
                  course: course.name,
                  instructor: instructor.first_name,
                  course_user_id: instructor.course_user_id,
                  usersubgroup_id: course.usersubgroup_id,
                  usersubgroup_name: course.usersubgroup.name,
                  subtype_id: course.type.id || null,
                  subtype_name: course.type.name || null,
                  institution_user_id: instructor.pivot.institution_user_id,
                  course_id: course.id,
                  selected: true
                });
                checkTeachersExist.push(instructor.id);
              }
            });
          });
          if (checkTeachersExist.length == 0) {
            this.$toast.warning("No users found!", {
              position: "top",
              duration: 3000,
            });
            this.selectedSubgroupsTeachers.splice(subgroupTeacherId, 1);
          }
        }
        // console.log('api',this.subgroupTeachers)

        response;
      });
      // this.loadTeachers = false;
    },
  },
};
</script>
<style>
#CTCModal .modal-body {
  overflow-x: auto;
}

/* same badge as the participants popup */
#CTCModal .class-programme-code {
  margin-left: 6px;
  padding: 1px 8px;
  font-size: 11px;
  color: #4a5568;
  background: #edf2f7;
  border-radius: 999px;
}
</style>